import { render, staticRenderFns } from "./EmployeesReviewBlock.vue?vue&type=template&id=59542590"
import script from "./EmployeesReviewBlock.vue?vue&type=script&lang=js"
export * from "./EmployeesReviewBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports